import { BAZAK_URL } from '@/common/constants';
import type { DisplayMode } from '@/lib/types/widget-types';
import { applyQueryParams } from '@/lib/utils/domain';

/** Which of our own surfaces the visitor clicked from — not the host page. */
export type WatermarkMedium = DisplayMode | 'inline' | 'standalone' | 'verification';

/** Where the "Powered by Bazak" watermark points, tagged so the traffic it sends us can be
 *  told apart by surface and by tenant. Out of the hook so a server-rendered page can use it. */
export function watermarkUrl({
  medium,
  tenantKey,
}: {
  medium: WatermarkMedium;
  tenantKey: string;
}): string {
  return applyQueryParams({
    url: BAZAK_URL,
    params: { utm_source: 'watermark', utm_medium: medium, utm_campaign: tenantKey },
  });
}
